var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-breadcrumb", { attrs: { name: "CTS Schedule Upload" } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12", lg: "8" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: {
                    title: "Upload CTS Weekly Schedule",
                    "sub-title":
                      "Upload the current CTS weekly schedule workbook. The in prog sheet will replace the existing weekly route assignments.",
                    "with-footer": "",
                    "second-body": !!_vm.importResult,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "b-btn",
                            {
                              attrs: {
                                variant: "primary",
                                disabled:
                                  _vm.formState.processing || !_vm.form.file,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.submitSchedule.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Upload Schedule\n            "
                              ),
                              _vm.formState.processing
                                ? _c("b-spinner", {
                                    staticClass: "ml-1",
                                    attrs: { small: "" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "second-body",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-wrap justify-content-between align-items-center mb-3",
                            },
                            [
                              _c("div", [
                                _c("h5", { staticClass: "mb-1" }, [
                                  _vm._v("Latest Import"),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "text-muted mb-0" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.importResult.source_sheet_name
                                      ) +
                                      " imported successfully.\n              "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("b-badge", { attrs: { variant: "success" } }, [
                                _vm._v(
                                  _vm._s(_vm.importResult.imported) + " rows"
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { sm: "6", md: "3" } }, [
                                _c("div", { staticClass: "summary-label" }, [
                                  _vm._v("Date Range"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "summary-value" }, [
                                  _vm._v(_vm._s(_vm.dateRange)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { sm: "6", md: "3" } }, [
                                _c("div", { staticClass: "summary-label" }, [
                                  _vm._v("Active Routes"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "summary-value" }, [
                                  _vm._v(_vm._s(_vm.importResult.active)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { sm: "6", md: "3" } }, [
                                _c("div", { staticClass: "summary-label" }, [
                                  _vm._v("Inactive Routes"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "summary-value" }, [
                                  _vm._v(_vm._s(_vm.importResult.inactive)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { sm: "6", md: "3" } }, [
                                _c("div", { staticClass: "summary-label" }, [
                                  _vm._v("Same-Day Routes"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "summary-value" },
                                  [
                                    _c(
                                      "b-badge",
                                      {
                                        attrs: {
                                          variant: _vm.importResult
                                            .same_day_enabled
                                            ? "success"
                                            : "secondary",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.importResult
                                                .same_day_enabled || 0
                                            ) +
                                            " enabled\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                    _vm._v(
                      "\n          Uploading a schedule replaces every row in the CTS weekly route assignments table.\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                    _c("strong", [_vm._v("Same-day pickups:")]),
                    _vm._v(" Set column A to "),
                    _c("code", [_vm._v("Yes")]),
                    _vm._v(", "),
                    _c("code", [_vm._v("Y")]),
                    _vm._v(",\n          "),
                    _c("code", [_vm._v("True")]),
                    _vm._v(", or "),
                    _c("code", [_vm._v("1")]),
                    _vm._v(
                      " for routes that permit same-day scheduling.\n          Same-day routes are available until 4:00 PM Mountain Time. Blank or unrecognized\n          values disable same-day scheduling for that route.\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.submitSchedule.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-for": "cts-weekly-schedule-file",
                            "invalid-feedback": _vm.validation.file,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n              Weekly Schedule Workbook "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "required-asterisk" },
                                    [_vm._v("*")]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c("b-form-file", {
                            attrs: {
                              id: "cts-weekly-schedule-file",
                              state: _vm.fieldState("file"),
                              placeholder:
                                "Choose the CTS schedule workbook or drop it here",
                              "drop-placeholder": "Drop workbook here",
                              accept:
                                ".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            },
                            model: {
                              value: _vm.form.file,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "file", $$v)
                              },
                              expression: "form.file",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }